import styled from 'styled-components';

export const Description = styled.p`
  white-space: nowrap;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
